<template>
    <u-chip-flat-pill v-bind="$attrs" color="#E0F2F1" text-color="#009688" @click="$emit('click')">
        <template v-for="(_, slotName) in $slots" #[slotName]>
            <slot :name="slotName" />
        </template>
    </u-chip-flat-pill>
</template>

<script>
import UChipFlatPill from "@/components/publish/styles/chips/u-chip-flat-pill.vue";

export default {
    props: {},
    components: {
        UChipFlatPill,
    },
    data() {
        return {};
    },
    mounted() {},
    methods: {},
};
</script>

<style lang="scss" scoped></style>
